<template>
  <div>
    <div class="sub_Navi">
      <ul>
        <li>
          <a class="back" href="javascript:window.history.back();">뒤로</a>
        </li>
        <li><h1>{{ $t('mypage["languageSetting"]') }}</h1></li>
        <li class="linkBox">
        </li>
      </ul>
    </div>
    <div class="subPage_container">
      <div class="set_check_list">
        <ul>
          <li @click="chooseLang('en')" :class="{ active: selectLang === 'en' }">
            <div class="lt_1">
              <h3 class="set_name">English</h3>
            </div>
            <div class="lt_2">
              <input type="radio" id="setChk_001" name="setChk" value="en" v-model="selectLang"/>
              <label for="setChk_001"></label>
            </div>
          </li>
          <li @click="chooseLang('ko')" :class="{ active: selectLang === 'ko' }">
            <div class="lt_1">
              <h3 class="set_name">한국어</h3>
            </div>
            <div class="lt_2">
              <input type="radio" id="setChk_002" name="setChk" value="ko" v-model="selectLang"/>
              <label for="setChk_002"></label>
            </div>
          </li>
          <li @click="chooseLang('ja')" :class="{ active: selectLang === 'ja' }">
            <div class="lt_1">
              <h3 class="set_name">日本語</h3>
            </div>
            <div class="lt_2">
              <input type="radio" id="setChk_003" name="setChk" value="ja" v-model="selectLang"/>
              <label for="setChk_003"></label>
            </div>
          </li>
          <li @click="chooseLang('zh')" :class="{ active: selectLang === 'zh' }">
            <div class="lt_1">
              <h3 class="set_name">中文</h3>
            </div>
            <div class="lt_2">
              <input type="radio" id="setChk_004" name="setChk" value="zh" v-model="selectLang"/>
              <label for="setChk_004"></label>
            </div>
          </li>
          <li @click="chooseLang('vi')" :class="{ active: selectLang === 'vi' }">
            <div class="lt_1">
              <h3 class="set_name">Tiếng Việt</h3>
            </div>
            <div class="lt_2">
              <input type="radio" id="setChk_005" name="setChk" value="vi" v-model="selectLang"/>
              <label for="setChk_005"></label>
            </div>
          </li>
          <li @click="chooseLang('ru')" :class="{ active: selectLang === 'ru' }">
            <div class="lt_1">
              <h3 class="set_name">Русский язык</h3>
            </div>
            <div class="lt_2">
              <input type="radio" id="setChk_006" name="setChk" value="ru" v-model="selectLang"/>
              <label for="setChk_006"></label>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="btn_bottom_wrap">
      <button type="button" class="btn_primary" @click="saveLang()">
        {{ $t('mypage.save') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { popupControll } from '@/utils/modalText';
import api from '@/api/apiAuth.js';

// vue-router 사용
const router = useRouter();
const { t, locale } = useI18n();

// active용 상태 변수를 만들고 현재 locale 값으로 초기화
const selectLang = ref(locale.value); 

const chooseLang = (lang) => {
  selectLang.value = lang;
};

const saveLang = () => {
  locale.value = selectLang.value;
  popupControll(t('popup.saved')); // this.t -> t 로 수정
  router.push('/user/setting');    // this.router -> router 로 수정
};

watch(locale, async (newlocale) => {
  localStorage.setItem("localeLang", newlocale);
  // 언어 설정변경 api 호출
  await api.chkUserLang(newlocale);
});
</script>